// React
import { ReactElement } from 'react';
// Next
import { useTranslation } from 'next-i18next';
// Modules
import classNames from 'classnames/bind';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Image } from '@utmb/design-system/image/Image';
import { Placeholder } from '@utmb/design-system/placeholder/Placeholder';
// Contexts
import { useDashboard } from '@utmb/contexts/DashboardContext';
import { useUser } from '@utmb/contexts/AuthContext';
// Utils
import { pIdToCloudinary } from '@utmb/utils/cloudinary';
// Styles
import styles from './my-dashboard-header.module.scss';

const cx = classNames.bind(styles);

export const MyDashboardOrganizerHeader = (): ReactElement | null => {
    const { dashboardOrganizer } = useDashboard();
    const { me } = useUser();
    const { profilePicture, fullname } = me!;
    const { t } = useTranslation();

    if (!dashboardOrganizer) {
        return null;
    }

    return (
        <div className={`${styles.container} ${styles.container_organizer}`}>
            <div
                className={cx(styles.left, {
                    spacing_if_profile_picture: profilePicture,
                })}
            >
                <Font.FuturaMedium className={styles.name} mobile="32" desktop="32">
                    {t('common.hi')} {dashboardOrganizer.name}
                </Font.FuturaMedium>
            </div>

            <div className={styles.bg_image_container}>
                {profilePicture ? (
                    <Image objectFit="cover" layout="fill" image={pIdToCloudinary(profilePicture, fullname)} />
                ) : (
                    <Placeholder logoWidth={60} logoHeight={60} />
                )}
            </div>
        </div>
    );
};
